<div class="container-fluid py-5">
    <div class="col-md-8 cah-signup-card offset-0 offset-md-2 offset-lg-2 offset-md-0  mt-0 mt-lg-5">
        <div class="d-flex">
            <div class="cah-signup-sec px-0 shadow d-lg-block d-none d-sm-none">
                <div class="py-5 cah-p-lr-40 text-white">
                    <h1 class="fw-bolder cah-font-35 mb-4">Specialist <br>Sign In</h1>
                    <p class="cah-font-16 mb-5">Get access to your account</p>
                    <div class="text-center py-5"><img src="{{assets}}img/auth/speci-graphic-left.png"></div>
                </div>
            </div>
            <div class="w-100 px-0">
                <form [formGroup]="form" >
                    <div class="w-100 cah-sign-up-step">
                        <div class="pt-5 px-5">
                            <p class="cah-font-16">Enter your email address below to Reset your Password</p>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Email Address</mat-label>
                                    <input 
                                    formControlName="email" 
                                    matInput 
                                    (keyup.enter)="checkEmail()"
                                    >
                                </mat-form-field>
                                <div class="message-block">
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['email'].hasError('required') && form.controls['email'].touched"
                                        >
                                        {{message.error[13]}}
                                    </div>
                                    <div class="mat-error error-message" *ngIf="form.controls['email'].hasError('differentEmail')"
                                    >
                                    {{message.error[57]}}
                            </div>
                                   
                                    <div class="mat-error error-message" *ngIf="form.controls['email'].hasError('invalidEmail')"
                                        >
                                        {{message.error[24]}}
                                </div>
    
                                    <div class="mat-error error-message"
                                        *ngIf="form.controls['email'].hasError('pattern') && form.controls['email'].touched"
                                        >
                                        {{message.error[14]}}
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-5">
                            <button 
                            type="submit" 
                            [disabled]="!form.valid" 
                            (click)="checkEmail()"
                            class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2">
                            Submit
                        </button>
                            <div class="text-center mt-4 pb-5"><a class="create-acc-link text-violet text-decoration-none ms-1 cah-font-16" routerLink="../specialist-signin">Cancel</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>